import http from "infra/http";
import { useQuery } from "react-query";
import { UserProfile } from "../typings/user";


export default function useProfile() {
  return useQuery("/v1/auth/profile", async () => {
    const { data } = await http.get<UserProfile>("/v1/auth/profile");

    return data;
  });
}
